export default function ({state, commit, dispatch}, val) {
    if (!val) return;
    val = val.trim();
    if (!val) return;
    if (state.form.AgreementCodes.indexOf(val) >= 0) {
        commit('set_system', {code: val});
        return;
    }
    dispatch('agreements/add', {
        id: val,
        cId: state.form.CertificateId ? state.form.ContragentID : '',
        cName: state.form.CertificateId ? state.form.ContragentName : '',
        cLegalId: state.form.CertificateId ? state.form.PartnerLegalEntityId : '',
        cLegalName: state.form.CertificateId ? state.form.PartnerLegalEntityName : '',
        cType: state.form.CertificateId ? state.form.ContragentType : '',
        callback: (agreement) => {
            agreement.requests.forEach(i => {
                switch (state.form.PaymentDirection) {
                    case 0:
                        i.sum = i.inp > 0 ? i.inp : 0;
                        break;
                    case 1:
                        i.sum = i.out > 0 ? i.out : 0;
                        break;
                }
            });
            dispatch('agreement_sum');
        }
    });
}